import { Car, Wrench, Home } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
    {
        icon: Car,
        title: "Remplacement de pare-brise",
        text: "Remplacement rapide et soigné avec des pièces de qualité constructeur.",
    },
    {
        icon: Wrench,
        title: "Réparation d'impact",
        text: "Réparation d'impact avant que la fissure ne s'étende. Intervention rapide en moins de 30 minutes.",
    },
    {
        icon: Home,
        title: "Intervention à domicile",
        text: "Nous venons chez vous ou sur votre lieu de travail. Gagnez du temps, on s'occupe de tout.",
    },
];

export const Services = () => (
    <section id="services" data-testid="services-section" className="relative bg-[#F7F5F1] py-24 scroll-mt-20">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <Reveal>
                <div className="flex items-center justify-center gap-5">
                    <span className="h-px w-14 sm:w-28 bg-gradient-to-l from-gold to-transparent" />
                    <h2 className="font-display font-extrabold uppercase tracking-wide text-2xl sm:text-4xl text-midnight-900">
                        Nos services
                    </h2>
                    <span className="h-px w-14 sm:w-28 bg-gradient-to-r from-gold to-transparent" />
                </div>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
                {SERVICES.map((service, i) => (
                    <Reveal key={service.title} delay={i * 0.12}>
                        <article
                            data-testid={`service-card-${i}`}
                            className="group h-full bg-white rounded-xl border border-black/5 shadow-[0_10px_40px_rgba(10,14,23,0.08)] p-9 text-center transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-2 hover:shadow-[0_25px_60px_rgba(10,14,23,0.15)] hover:border-gold/60"
                        >
                            <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-midnight-800 border-2 border-gold text-gold transition-transform duration-500 group-hover:scale-110">
                                <service.icon size={26} strokeWidth={1.75} />
                            </span>
                            <h3 className="mt-6 font-display font-extrabold uppercase tracking-wide text-base text-midnight-900">
                                {service.title}
                            </h3>
                            <p className="mt-3 text-sm text-gray-500 leading-relaxed">{service.text}</p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
